module.exports = __webpack_public_path__ + "img/李文荣-4x.141ced8f.png";